import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { isEmpty } from 'lodash';
import { getCurrentYear } from '../utils/Date';

interface YearDropdownProps {
  label?: string;
  width?: number;
  backgroundColor?: string;
  disabled?: boolean;
  allowSelectAll?: boolean;
  defaultToCurrentYear?: boolean;
  options: number[];
  value: number | null;
  onChange: (newValue: number | null) => void;
}

const YearDropdown = (props: YearDropdownProps) => {
  const { t } = useTranslation();

  const handleChange = (e: any) => {
    const newValue = e.target.value as number;
    props.onChange(newValue < 0 ? null : newValue);
  };

  const currentYear = getCurrentYear();

  return (
    <FormControl
      size='small'
      sx={{ width: props.width ?? 250, backgroundColor: props.backgroundColor }}
    >
      {props.label && <InputLabel>{props.label}</InputLabel>}
      <Select
        value={props.value ?? -1}
        label={props.label}
        onChange={handleChange}
        name='select'
        required
      >
        {props.allowSelectAll && (
          <MenuItem value={-1} key={-1}>
            {t('shared.all')}
          </MenuItem>
        )}
        {props.options.map((year) => (
          <MenuItem value={year} key={year}>
            {year.toString()}
          </MenuItem>
        ))}
        {props.defaultToCurrentYear && isEmpty(props.options) ? (
          <MenuItem value={currentYear} key={currentYear}>
            {currentYear}
          </MenuItem>
        ) : undefined}
      </Select>
    </FormControl>
  );
};

export default YearDropdown;
